import { createAsyncThunk } from '@reduxjs/toolkit';
import ChatApi from '../../../infrastructure/chat-api';
import ProposalApi from '../../../infrastructure/proposal-api';
import { getErrorPayload } from '../../helpers/api-helper';
export const initiateChatAsync = createAsyncThunk('chat/initiate', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ChatApi.initiateChat(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const sendMessageAsync = createAsyncThunk('chat/answer', async (message, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ChatApi.sendMessage(message);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getChatHistoryAsync = createAsyncThunk('chat/history', async (historyRequest, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ChatApi.getChatHistory(historyRequest);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const cleanChatAsync = createAsyncThunk('chat/clean', async (cleanRequest, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ChatApi.cleanChat(cleanRequest);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadChatAsync = createAsyncThunk('chat/DownloadChat', async (message, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ChatApi.downloadChat(message);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const downloadDocumentAsync = createAsyncThunk('chat/DownloadDocumnet', async (message, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ChatApi.downloadDocument(message);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getClausesAsync = createAsyncThunk('chat/getClauses', async ({ proposalId }, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.getClauses(proposalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAnalysisAsync = createAsyncThunk('chat/getAnalysis', async (proposalId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.getAnalysis(proposalId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const rollbackClauseAnswerAsync = createAsyncThunk('chat/rollbackClauseAnswer', async ({ proposalId, clauseId, questionId, versionId }, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ProposalApi.rollbackClauseAnswer(proposalId, clauseId, questionId, versionId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
